<template>
    <object-add-form></object-add-form>
</template>


<script>

    import ObjectAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            ObjectAddForm,
        },

    }
</script>

